import React from "react";
import { useDroppable } from "@dnd-kit/react";

const DroppableStage = ({
  stageId,
  children,
  containerClassName,
}: {
  stageId: string;
  children: React.ReactNode;
  containerClassName?: string;
}) => {
  const { ref, isDropTarget } = useDroppable({
    id: `stage-${stageId}`,
    data: {
      type: "stage",
      stageId,
    },
  });

  return (
    <div
      ref={ref}
      className={`flex flex-col gap-[8px] overflow-x-hidden overflow-y-auto no-scrollbar transition-colors min-h-[160px] ${
        isDropTarget ? "bg-blue-50 dark:bg-blue-900/20 rounded-[8px]" : ""
      } ${containerClassName}`}
    >
      {children}
    </div>
  );
};

export default DroppableStage;
